import React from 'react';

export default React.createContext({keyboardShown: null});
